import { Paper, Box, Typography, Stack } from '@material-ui/core';
import CallMadeIcon from '@material-ui/icons/CallMade';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import RemoveIcon from '@material-ui/icons/Remove';

/* eslint-disable no-nested-ternary */
export const KpiCard = ({ label, value, delta, trend, hint }) => {
  const Icon = trend === 'up' ? CallMadeIcon : trend === 'down' ? CallReceivedIcon : RemoveIcon;
  const tone = trend === 'up' ? '#6E8C4B' : trend === 'down' ? '#B23A2F' : '#5A6A5C';
  return (
    <Paper
      elevation={0}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 3,
        background: 'linear-gradient(160deg, #FBF7EE 0%, #F2EBD8 100%)',
        border: '1px solid',
        borderColor: 'divider',
        p: 2.5,
        boxShadow: '0 2px 10px -4px rgba(31,58,44,0.08)',
        transition: 'box-shadow .25s',
        '&:hover': { boxShadow: '0 14px 36px -16px rgba(31,58,44,0.25)' }
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: -50,
          right: -50,
          width: 130,
          height: 130,
          borderRadius: '50%',
          bgcolor: 'rgba(201,138,46,0.1)',
          filter: 'blur(28px)'
        }}
      />
      <Box sx={{ position: 'relative' }}>
        <Typography variant="overline" color="text.secondary" sx={{ fontSize: 11 }}>
          {label}
        </Typography>
        <Typography
          sx={{ fontFamily: "'Fraunces', serif", fontSize: 30, fontWeight: 600, mt: 1.5 }}
        >
          {value}
        </Typography>
        <Stack
          direction="row"
          spacing={0.75}
          sx={{ mt: 1, color: tone, fontSize: 14, alignItems: 'center' }}
        >
          <Icon size={14} />
          <Typography sx={{ fontWeight: 500, fontSize: 14, color: tone }}>{delta}</Typography>
          <Typography color="text.secondary" sx={{ fontSize: 13 }}>
            · {hint}
          </Typography>
        </Stack>
      </Box>
    </Paper>
  );
};
